import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const BladesHorizontal = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='BladesHorizontal' {...props}>
    <path fillRule='evenodd' clipRule='evenodd' d='M4 2C2.89543 2 2 2.89543 2 4V20C2 21.1046 2.89543 22 4 22H6C7.10457 22 8 21.1046 8 20V4C8 2.89543 7.10457 2 6 2H4ZM4 4L6 4V16H4V4ZM4 18V20H6V18H4ZM11 2C9.89543 2 9 2.89543 9 4V20C9 21.1046 9.89543 22 11 22H13C14.1046 22 15 21.1046 15 20V4C15 2.89543 14.1046 2 13 2H11ZM11 4L13 4V16H11V4ZM11 18H13V20H11V18ZM16 4C16 2.89543 16.8954 2 18 2H20C21.1046 2 22 2.89543 22 4V20C22 21.1046 21.1046 22 20 22H18C16.8954 22 16 21.1046 16 20V4ZM20 4L18 4V16H20V4ZM20 18H18V20H20V18Z' fill='#000' />
  </StyledIcon>
);
